import {
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import * as _ from 'lodash';

import { TableComponent } from 'shared/table/table/table.component';
import * as utils from 'utils/utils';
import { marketingCodeLookup } from 'utils/lookups';


@Component({
  template: '',
})
export class BaseSegmentComponent extends TableComponent {

  @Input() itemDetail: any = {};

  @Input() marketingCopy: any = {};

  @Input() itemId: any;

  @Input() selectedLanguage: string = 'EN';

  @Output() dataChange: EventEmitter<any> = new EventEmitter();

  getDescriptionProperty(item: any): string {
    return utils.getItemProperty(
      item,
      `${item.item_name}.${this.selectedLanguage}`,
      this.itemDetail
    );
  }

  groupMarketingByCode(marketingName: string): any {
    return _.values(_.groupBy(this.marketingCopy[marketingName], 'code'));
  }

  /**
    * Group data by type(GCC or FAB) and language
    * @returns {Array}
    * @example:
    [
      [
        {
          code: 'BOW',
          code_title: 'Brand Owner',
          assignment_title: 'Marketing Group',
          assignment_code: 'MGT',
          data: {
            GCC: {
              EN: [{title, description, code, type, language}, {}, {}],
              ES: [{title, description, code, type, language}, {}, {}],
              FR: [{title, description, code, type, language}, {}, {}],
            },
            FAB: {
              EN: [{title, description, code, type, language}, {}, {}],
              ...
            }
          }
        },
        {}
      ],
      [...]
    ]
  **/
  groupMarketingByType(data: Array<any>): Array<any> {
    return _.reduce(data, (memo: any, group: Array<any>) => {
      const groupedData: any = {
        'code_title': utils.getLookupTitle(group[0].code, marketingCodeLookup),
        'assignment_title': group[0].assignment_title,
        'assignment_code': group[0].assignment_code,
        'code': group[0].code,
      };
      _.each(group, (item: any) => {
        // path for saving items Array
        const path = `data.${item.type}.${item.language}`;
        if (!_.has(groupedData, path)) { _.set(groupedData, path, []); }
        const arr: any = _.get(groupedData, path);
        _.set(groupedData, path, _.concat(arr, [item]));
      });
      memo.push(groupedData);
      return memo;
    }, []);
  }
}
